import url from './url';
const AppConsts = {
  userManagement: {
    defaultAdminUserName: 'admin',
  },
  localization: {
    defaultLocalizationSourceName: 'OCVCApp',
  },
  authorization: {
    encrptedAuthTokenName: 'enc_auth_token',
    tokenExpName: 'token_exp_time',
    tokenDurationSecondsName: 'token_duration',
    isTimeoutCookieName: 'did_timeout',
  },
  appBaseUrl: 'http://ocvcapp.localhost:8081',
  remoteServiceBaseUrl: url,

  // user inactivity default timeout
  defaultInactivityTimeoutMinutes: 10,
  defaultInactivityTimeoutMinAdvocate: 30,
  accessTokenDefaultExpirationSeconds: 900, // 15 min.

};
export default AppConsts;
